import React, { FC } from 'react';

import Input from 'components/Input/Input';

import { NumberFieldConfig, Spacing, SPACING_MAP } from '../FormFields.types';
import { getFormFieldValue } from '../FormFields.utils';

import { useFormFieldsContext } from '../../../context';

interface IFormFieldsNumberRowProps {
  fields: NumberFieldConfig[];
  spacing?: Spacing;
}

export const FormFieldsNumberRow: FC<IFormFieldsNumberRowProps> = ({
  fields,
  spacing = 'none'
}): React.ReactElement => {
  const { values, getFieldProps } = useFormFieldsContext();

  return (
    <div className={`flex gap-5 ${SPACING_MAP[spacing]}`.trim()}>
      {fields.map(({ label, name, min, max, isRequired, leftIcon, leftIconStyles }) => {
        const fieldProps = getFieldProps(name);
        return (
          <Input
            key={name}
            label={label}
            isRequired={isRequired}
            name={name}
            type="number"
            min={min}
            max={max}
            value={Number(getFormFieldValue<number>(values, name) ?? 0)}
            onChange={fieldProps.onChange}
            onBlur={fieldProps.onBlur}
            leftIcon={leftIcon}
            leftIconStyles={leftIconStyles}
            className="flex-1"
          />
        );
      })}
    </div>
  );
};
